const STORAGE_KEY = "RB_ADMIN_KEY";

export async function isAdmin() {
  const key = localStorage.getItem(STORAGE_KEY);
  if (!key) return false;
  try {
    const r = await fetch("/api/admin/ping", {
      headers: { "x-admin-key": key },
    });
    return r.ok;
  } catch {
    return false;
  }
}

/** Versione “veloce”: ritorna true solo se c'è la chiave salvata. 
 *  Utile per nascondere subito le voci, poi puoi fare una verifica vera in background. */
export function isAdminCached() {
  return !!localStorage.getItem(STORAGE_KEY);
}

export function adminLogout() {
  localStorage.removeItem(STORAGE_KEY);
}
